import React, { useMemo } from 'react'
import { Plus } from 'react-feather'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { ButtonOutline, RedDot, SearchInput, StatusFilter, Table, MobileTable } from '../../components'
import { DashboardLayout } from '../../layouts'
import colors from '../../utils/colors'
import makeData from './makeData'

const AddButton = () => {
  return (
    <Link
      className="text-sm text-primary flex items-center cursor-pointer"
      to="/dashboard/events/form"
    >
      <Plus className="mr-1" style={{width: '18px'}}/>
      <p>Add</p>
    </Link>
  )
}

const DashboardEvents = () => {
  const tableData = useMemo(() => makeData(60), [])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Title',
        accessor: 'title',
      },
      {
        Header: 'Cities',
        accessor: 'city',
      },
      {
        Header: 'Date',
        accessor: 'date',
      },
      {
        Header: 'Guests',
        accessor: 'guests',
        Cell: ({ value, row}) => (
          <div className="flex items-center">
            <div className="mr-1">{value ? value : '-'}</div>
            {row.original.unread && <div><RedDot /></div>}
          </div>
        )
      },
      {
        Header: 'Visibility',
        accessor: 'visibility',
      },
      {
        Header: 'Event Status',
        accessor: 'status',
        Cell: ({ value }) => (
          value === 'upcoming' ? (
            <span style={{color: colors.orange}}>Upcoming</span>
          ) : value === 'ongoing' ? (
            <span style={{color: colors.green}}>Ongoing</span>
          ) : (
            <span className="text-gray-999">Completed</span>
          )
        )
      },
      {
        Header: 'Submission',
        accessor: 'submission',
        Cell: ({ value }) => (
          value === 'under_review' ? (
            <span style={{color: '#EAA800'}}>Under review</span>
          ) : value === 'approved' ? (
            <span style={{color: '#2BB36F'}}>Approved</span>
          ) : (
            <span className="text-gray-999">Draft</span>
          )
        )
      },
      // {
      //   Header: () => <div></div>,
      //   id: 'action',
      //   Cell: () => (
      //     <div className="flex items-center">
      //       <Link to="/dashboard/events/form">
      //         <p className="cursor-pointer underline text-sm text-primary mr-8">Edit</p>
      //       </Link>
      //       <p className="cursor-pointer underline text-sm text-gray-999">Delete</p>
      //     </div>
      //   )
      // }
    ],
    []
  )

  return (
    <DashboardLayout
      title="Our Events"
      addButton={<AddButton />}
    >
      <div className="hidden xl:flex justify-between items-start">
        <h1 className="text-4xl font-bold font-primary mb-8">
          Our Events
        </h1>
        <Link
          className="text-sm text-primary flex items-center cursor-pointer"
          to="/dashboard/events/form"
        >
          <Plus className="mr-1" style={{width: '14px'}}/>
          <p>Create Event</p>
        </Link>
      </div>

      <div style={{maxWidth: '370px'}} className="mt-6 xl:mt-0 mb-6 lg:mb-8">
        <SearchInput />
      </div>

      <div className="mb-5 lg:mb-8">
        <StatusFilter />
      </div>

      <div className="mb-8 flex items-center">
        <Select
          placeholder="Choose action"
          options={[]}
          className="text-sm mr-4 lg:mr-2 w-full lg:w-1/4"
        />
        <ButtonOutline
          outlineColor="primary"
          className="text-primary"
          style={{maxWidth: '87px'}}
        >
          Apply
        </ButtonOutline>
      </div>

      <hr className="mb-8 lg:mb-4" />

      {/* Desktop Table */}
      <div className="hidden lg:block mb-12">
        <Table
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>

      {/* Mobile Table */}
      <div className="lg:hidden mobile-fullwidth mb-12">
        <MobileTable
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>
    </DashboardLayout>
  )
}

export { DashboardEvents }
